import React from 'react';
import Tooltip from 'mrf/view/Tooltip';
import { generateHtmlId } from 'mrf/utils/StringGenerators';
import { StyledButtonIcon } from 'mrf/styles/components/Icon.styles';

export default function ButtonIcon({ icon: Icon, iconColor='normal', color='primary', tooltip, size=5, htmlId, ...props }) {
    const originalOnClick = props?.onClick;
    if (originalOnClick) {
        props.onClick = function(e) {
            e.preventDefault();
            originalOnClick.apply(null, arguments);
        }
    }

    // Set the element id inside the StyledButton or inside the Component
    htmlId = htmlId ?? generateHtmlId("button_icon", tooltip);

    return (
        <Tooltip content={tooltip}>
            <StyledButtonIcon iconColor={iconColor} color={color} size={size} id={htmlId} {...props}>
                <Icon />
            </StyledButtonIcon>
        </Tooltip>
    );
}